<template>
	<div class="job-fuzzy-matrix--row">
		<ValueGroup
			v-for="item in valueGroups"
			:key="row.id + '-' + item.category.id"
			:category="item.category"
			:row="row"
			:values="item.values"
			@filterValue="$emit('filterValue', $event)"
		/>
	</div>
</template>

<script>
import ValueGroup from "./ValueGroup";
import _ from "lodash";

export default {

	components: {
		ValueGroup,
	},

	props: {
		row: {
			type: Object,
			required: true,
		},
	},

	computed: {
		valueGroups ()
		{
			let grouped = [];

			_.forEach(this.row.values, value =>
			{
				const category = value.category;

				let group = _.find(grouped, group => group.category.id === category.id);

				if (!group)
				{
					group = {
						category,
						values: [],
					};

					grouped.push(group);
				}

				group.values.push(value);
			});

			grouped.sort((a, b) =>
			{
				return a.category.sort === b.category.sort
					? 0
					: (a.category.sort > b.category.sort ? 1 : -1);
			});

			return grouped;
		},
	}
}
</script>
